
import {Injectable} from '@angular/core';
import {ApiService} from "../../api.service";

@Injectable({
  providedIn: 'root'
})
export class ApiAdminCustomerService {

  apiUri = '/api/admin/customer'
  apiUrlWithPaginations = 'api/admin/customerwithpagination'

  constructor(private apiService: ApiService) {
  }

  listAllPaginated(page: number, perPage: number) {
    let params = {
      'page': page ?? '',
      'perPage': perPage ?? ''
    };
    return this.apiService.get(this.apiUrlWithPaginations, params);
  }

  listAll() {
    return this.apiService.get(this.apiUri);
  }

  get(id) {
    return this.apiService.get(`/api/v2/admin/customer/${id}`);
  }

  options() {
    return this.apiService.get(`/api/v2/admin/customer/options`);
  }

  delete(id) {
    return this.apiService.delete(`${this.apiUri}/${id}`);
  }

  create(data) {
    return this.apiService.post(`/api/v2/admin/customer`, data);
  }

  intuneSync(id) {
    return this.apiService.get(`/api/intune/authorise/${id}`);
  }

  update(id, data) {
    return this.apiService.put(`/api/v2/admin/customer/${id}`, data);
  }


}



